import { getBooleanFromValue, unwrap } from '@/global/utils/utils'

const TAB_KEY = 'digitalSensors'
const DATA_KEY = 'digital_sensor'
export default {
  computed: {
    digitalSensorsConfig () {
      return {
        title: this.$t('base/tracker.digital_sensors'),
        key: TAB_KEY,
        visible: getBooleanFromValue(this.permissions?.canReadDigitalSensors),
        apiConfig: {
          get: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/digital-sensors`
          },
          post: {
            module: 'base',
            route: `tracker/${this.resolveRouteParamValue('id')}/digital-sensors`
          }
        },
        modifyDataBeforeSend: (event) => this.onModifyDigitalSensorsBeforeSend(event),
        hiddenFormKeys: [
          DATA_KEY
        ],
        tabContent: [
          {
            component: this.tabActionButtonsComponent,
            title: this.$t('base/tracker.digital_sensors'),
            showBackButton: {
              onGoBack: () => this.navigatesToTableView(this.trackersOverviewViewName)
            }
          },
          {
            component: this.digitalSensorsViewComponent,
            dataKey: DATA_KEY
          }
        ]
      }
    }
  },

  methods: {
    onModifyDigitalSensorsBeforeSend (event) {
      const { copiedData } = event || {}
      const flattenedData = unwrap(copiedData, { keys: [DATA_KEY] })

      flattenedData.digital_sensors_status = flattenedData?.is_active ?? null
      delete flattenedData.is_active

      return flattenedData
    }
  }
}
